<script>
import MSelectPulldown from '@/components/MSelectPulldown/index.vue'
export default {
  components: {
    MSelectPulldown
  },
  props: {
    value: {
      type: [Number, String]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      required: false
    },
    autoSelectDefault: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      localValue: this.value,
      page: {
        enabled: true,
        page: 1,
        size: 10,
        total: 0
      }
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    onItemChecked(checkedItem) {
      this.$emit('input', checkedItem.id)
      this.$emit('change', checkedItem)
    },
    loadData(keyword) {
      return new Promise((resolve, reject) => {
        const params = {
          ...this.queryParams,
          ourFlag: this.$enums.YES_OR_NO.YES.value,
          customerShortName: keyword
        }
        delete params.total
        delete params.enabled
        this.$store.dispatch('bu_customer/fetchOptions', params).then(res => {
          resolve({
            data: res.data.records
          })
          this.page.total = res.data.total

          // 开启了自动选中
          if (this.autoSelectDefault) {
            if (!this.value && this.page.total === 1) {
              this.onItemChecked(res.data.records[0])
            }
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    onSearch(keyword) {
      console.log('onSearch', keyword)
    },
    async fetchObject(value) {
      return await this.$store.dispatch('bu_customer/fetchObject', value);
    }
  }
}
</script>

<template>
  <m-select-pulldown
    v-model="localValue"
    ref="pulldown"
    :disabled="disabled"
    :clearable="clearable"
    :fetch-options="loadData"
    :fetch-object="fetchObject"
    :page="page"
    :field="{ value: 'id', label: 'customerShortName' }"
    :group="{ enabled: false }"
    :placeholder="placeholder"
    @checked="onItemChecked"
    @search="onSearch"
  >
    <template #content="{ list }">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item padding-sm cursor"
        :class="{
          'active': item.id === localValue
        }"
        @click="$refs.pulldown.onItemChecked(item)"
      >
        <div class="flex justify-between">
          <div>
            <span class="text-bold" style="color: var(--color-text-1);">{{ item.customerName }}</span>
            <!-- <span style="display: inline-block;margin-left: 10px;">{{ item.customerShortName }}</span> -->
          </div>
          <div>
            <span class="label">简称：</span>
            <span>{{ item.customerShortName }}</span>
          </div>
        </div>
        <!-- <div class="flex justify-between margin-top-sm">
          <div>
            <span class="label">签订日期：</span>
            <span>{{ item.signDate }}</span>
          </div>
          <div>
            <span class="label">乙方：</span>
            <span>{{ item.partyBName }}</span>
          </div>
        </div> -->
      </div>
    </template>
  </m-select-pulldown>
</template>

<style scoped lang="scss">
  .item {
    background: var(--color-fill-2);
    border-radius: 4px;
    position: relative;
    overflow: hidden;

    &.active::after {
      content: '';
      position: absolute;
      top: -1em;
      left: -1em;
      width: 2em;
      height: 2em;
      transform: rotate(45deg);
      background: var(--color-success);
    }
    &.active::before {
      /* content: '◉'; */
      position: absolute;
      top: 0.2em;
      left: 0.2em;
      color: var(--color-white);
      z-index: 1;
    }

    & ~ & {
      margin-top: 12px;
    }
  }
  .label {
    font-size: 12px;
    color: var(--color-text-3);
  }
</style>
